import { Controller } from "@hotwired/stimulus";

export default class MarketingNotificationController extends Controller {
  static values = { id: Number };
  static targets = ["bar", "modal"];

  connect() {
    // $(...).modal("show") failed here with "modal is not a function" for early hits,
    // so we're using the native API directly. The bar's "Read more" opens it via data-bs-toggle.
    this.modal = window.bootstrap.Modal.getOrCreateInstance(this.modalTarget);

    // A separate key for each announcement lets a newer announcement show the bar again.
    this.storageKey = `marketing-announcement-dismissed:${this.idValue}`;
    this.onBeforeCache = () => this.cleanup();
    document.addEventListener("turbo:before-cache", this.onBeforeCache);

    let dismissed = false;
    try {
      dismissed = window.localStorage.getItem(this.storageKey) === "true";
    } catch (_) {
      // Restricted storage must not prevent showing or closing the announcement.
    }
    if (dismissed) this.barTarget.classList.add("d-none");
  }

  dismissBar() {
    this.barTarget.classList.add("d-none");
    try {
      window.localStorage.setItem(this.storageKey, "true");
    } catch (_) {}
  }

  dismiss() {
    this.modal.hide();
  }

  disconnect() {
    this.cleanup();
  }

  cleanup() {
    if (!this.modal) return;
    // There is no fade transition, so hiding removes the backdrop and restores
    // scrolling synchronously before disposal and Turbo snapshot caching.
    document.removeEventListener("turbo:before-cache", this.onBeforeCache);
    this.modal.hide();
    this.modal.dispose();
    this.modal = null;
  }
}
